import ApiService from '@/api';
import {
  AddOrRemoveTaskEventDataModel,
  Events,
  RemoveTaskResponseEventModel,
  ResponseModel,
} from '../models';
import {
  mapSubscribeTaskListRequest,
  mapUnSubscribeTaskListRequest,
} from './UpdateTaskAdapterServiceMappers';

export class UpdateTaskAdapterService {
  private static instance: UpdateTaskAdapterService;

  private readonly api = new ApiService();

  static getInstance() {
    if (!UpdateTaskAdapterService.instance) {
      UpdateTaskAdapterService.instance = new UpdateTaskAdapterService();
    }
    return UpdateTaskAdapterService.instance;
  }

  /**Событие обновления задачи */
  OnUpdateTaskEvent = new Events<number>();
  /**Событие удаления задачи */
  OnRemoveTaskEvent = new Events<RemoveTaskResponseEventModel>();
  /**Событие удаление или добавление задачи сотруднику */
  OnAddOrRemoveEmployeeTask = new Events<AddOrRemoveTaskEventDataModel>();

  constructor() {
    this.api.Main.ProjectTaskSaveService.OnUpdateTaskNameEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) this.OnUpdateTaskEvent.trigger(resp.Value.TaskId);
    });
    this.api.Main.ProjectTaskSaveService.OnUpdateTaskStatusEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) this.OnUpdateTaskEvent.trigger(resp.Value.TaskId);
    });
    this.api.Main.ProjectTaskSaveService.OnUpdateTaskPriorityEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) this.OnUpdateTaskEvent.trigger(resp.Value.TaskId);
    });
    this.api.Main.ProjectTaskSaveService.OnUpdateTaskDifficultyEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) this.OnUpdateTaskEvent.trigger(resp.Value.TaskId);
    });
    this.api.Main.ProjectTaskSaveService.OnUpsertFinalEstimateTaskEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) this.OnUpdateTaskEvent.trigger(resp.Value.TaskId);
    });
    this.api.Main.ProjectTaskSaveService.OnRemoveTaskEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) this.OnRemoveTaskEvent.trigger(resp.Value);
    });
    this.api.Main.ProjectTaskSaveService.OnAddOrRemovePerformerToTaskInProjectEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.OnAddOrRemoveEmployeeTask.trigger(
          new AddOrRemoveTaskEventDataModel({
            ProjectId: resp.Value.Id,
            ProjectName: resp.Value.Name,
            ProjectImageUrl: resp.Value.ImageUrl,
            ProjectPreviewColor: resp.Value.PreviewColor,
          }),
        );
      }
    });
  }

  /**Задачи на подписке */
  private subscribeTasksIds = new Array<number>();

  /**
   * Подписаться на изменение списка задач
   * @param tasks Список задач
   * @returns
   */
  subscribeTaskList = (tasks: Array<number>) => {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      const tasksToSubscribe = tasks.filter(
        (taskId) => !this.subscribeTasksIds.some((_taskId) => taskId === _taskId),
      );

      if (!tasksToSubscribe.length) {
        result.Value = true;
        result.IsSuccess = true;
        return resolve(result);
      }

      this.subscribeTasksIds.push(...tasksToSubscribe);

      await this.api.Main.ProjectTaskSaveService.subscribeToDetailTaskListAsync(
        mapSubscribeTaskListRequest(tasksToSubscribe),
      )
        .then((resp) => {
          result.Value = !!resp;
          result.IsSuccess = !!resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR subscribeTaskList', e);
          return resolve(result);
        });
    });
  };

  /**
   * Отписаться от изменение списка задач
   * @returns
   */
  unSubscribeTaskList = () => {
    return new Promise<ResponseModel<boolean>>(async (resolve) => {
      const result = new ResponseModel<boolean>();

      if (!this.subscribeTasksIds.length) {
        result.IsSuccess = true;
        result.Value = true;
        return resolve(result);
      }

      await this.api.Main.ProjectTaskSaveService.unSubscribeToDetailTaskListAsync(
        mapUnSubscribeTaskListRequest(this.subscribeTasksIds),
      )
        .then((resp) => {
          result.Value = !!resp;
          result.IsSuccess = !!resp;
          this.subscribeTasksIds = [];
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR unSubscribeTaskList', e);
          return resolve(result);
        });
    });
  };
}
